<div class="table-container">
<h2>Arbitrage Profit History</h2>
    <table class="profit-table">
    <thead>
      <tr>
        <th>Sl Num</th>
        <th>Coin</th>
        <th>Buy Exchange</th>
        <th>Sell Exchange</th>
        <th>Profit</th>
        <th>Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let entry of profitData; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{ entry.pair }}</td>
        <td>{{ entry.buyExchange }}</td>
        <td>{{ entry.sellExchange }}</td>
        <td>{{ entry.profit }}</td>
        <td>{{ entry.time | date: 'short' }}</td>
      </tr>
    </tbody>
  </table>
</div>
